<template>
    <div class="no-sidebar-bg">
        <DynamicDialog />
        <Toast position="top-right" />
        <div class="w-full">
            <NuxtPage />
        </div>
    </div>
</template>

<script setup lang="ts">
import DynamicDialog from 'primevue/dynamicdialog';
import Toast from 'primevue/toast';
</script>

<style lang="scss" scoped>
.no-sidebar-bg {
    background: url('~/assets/images/soc/bg_2.png');
    background-color: var(--rail-bg);
    min-height: 100vh;
    background-size: 50%;
    background-attachment: fixed;
    overflow:auto;
    padding: 24px 32px;
}

</style>
